module.exports = __webpack_public_path__ + "static/img/EQUIPTOP.5bef0f35.png";